import { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Col,
  InputMask,
  Row,
  Span,
  Form,
  Button,
  RadioGroup,
  Picker
} from 'components'
import {
  withDateColor,
  rangeIsInvalid,
  hasInvalidDate
} from 'components/DatePicker/utils'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import {
  EffectiveParamsServices,
  IEffectiveParams
} from 'services/NGT/EffectiveParams'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import * as Yup from 'yup'

const Effective: React.FC = () => {
  const schema = Yup.object({
    vlJustVariacaoMaxEfetivo: Yup.string().required('Campo obrigatório'),
    vlJustVariacaoMinEfetivo: Yup.string().required('Campo obrigatório'),
    vlJustVariacaoNumHomemMax: Yup.string().required('Campo obrigatório'),
    vlJustVariacaoNumHomemMin: Yup.string().required('Campo obrigatório'),
    vlVariacaoHorasExtras: Yup.string().required('Campo obrigatório')
  })

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm<IEffectiveParams>({
    defaultValues: {
      dsFimFechamentoAnalista: null,
      dsFimFechamentoFornecedorContraparte: null,
      dsInicioFechamentoAnalista: null,
      dsInicioFechamentoFornecedorContraparte: null,
      flValorHeSalarioBasePorColaborador: false,
      vlJustVariacaoMaxEfetivo: 0,
      vlJustVariacaoMinEfetivo: -0,
      vlJustVariacaoNumHomemMax: 0,
      vlJustVariacaoNumHomemMin: -0,
      vlVariacaoHorasExtras: 0
    },
    resolver: yupResolver(schema)
  })

  const { loading, msgErro, setLoading, setMsgErro } = useLoading()
  const [isModalOpen, toggleModal] = useToggle()
  const { showModal } = useModal()

  const [effectiveParamsData, setEffectiveParamsData] =
    useState<IEffectiveParams>()

  const [
    dsInicioFechamentoFornecedorContraparte,
    setInicioFechamentoFornecedorContraparte
  ] = useState(effectiveParamsData?.dsInicioFechamentoFornecedorContraparte)
  const [diaFornecedorIni, setDiaFornecedorIni] = useState('')

  const [
    dsFimFechamentoFornecedorContraparte,
    setFimFechamentoFornecedorContraparte
  ] = useState(effectiveParamsData?.dsFimFechamentoFornecedorContraparte)
  const [diaFornecedorFim, setDiaFornecedorFim] = useState('')

  const [dsInicioFechamentoAnalista, setInicioFechamentoAnalista] = useState(
    effectiveParamsData?.dsInicioFechamentoAnalista
  )

  const [diaAnalistaIni, setDiaAnalistaIni] = useState('')
  const [dsFimFechamentoAnalista, setFimFechamentoAnalista] = useState(
    effectiveParamsData?.dsFimFechamentoAnalista
  )
  const [diaAnalistaFim, setDiaAnalistaFim] = useState('')

  const onChangediaFornecedorIni = (value) => {
    setDiaFornecedorIni(value)
    setInicioFechamentoFornecedorContraparte(FORMAT.formatDD(value))
  }

  const onChangediaFornecedorFim = (value) => {
    setDiaFornecedorFim(value)
    setFimFechamentoFornecedorContraparte(FORMAT.formatDD(value))
  }

  const onChangediaAnalistaIni = (value) => {
    setDiaAnalistaIni(value)
    setInicioFechamentoAnalista(FORMAT.formatDD(value))
  }

  const onChangediaAnalistaFim = (value) => {
    setDiaAnalistaFim(value)
    setFimFechamentoAnalista(FORMAT.formatDD(value))
  }

  const handleReset = () => {
    reset()
    onChangediaAnalistaIni(null)
    onChangediaAnalistaFim(null)
    onChangediaFornecedorFim(null)
    onChangediaFornecedorIni(null)
  }

  const getNegativeNumber = (number: number | string): number => {
    if (String(number).includes('-')) {
      return Number(number)
    }

    return -number
  }

  const updateEffectiveParams = (data) => {
    const fornecedor = {
      fim: dsFimFechamentoFornecedorContraparte,
      inicio: dsInicioFechamentoFornecedorContraparte
    }

    const analista = {
      fim: dsFimFechamentoAnalista,
      inicio: dsInicioFechamentoAnalista
    }

    if (
      hasInvalidDate([
        fornecedor.inicio,
        fornecedor.fim,
        analista.inicio,
        analista.fim
      ])
    ) {
      return
    }

    if (rangeIsInvalid(fornecedor.inicio, fornecedor.fim)) {
      setLoading('error')
      setMsgErro(
        'A data final deve ser maior que a inicial no fechamento fornecedor'
      )
      return
    }

    if (rangeIsInvalid(analista.inicio, analista.fim)) {
      setLoading('error')
      setMsgErro(
        'A data final deve ser maior que a inicial no fechamento analista'
      )
      return
    }

    if (data.idParametrizacaoEfetivo > 0) {
      setLoading('loading')

      EffectiveParamsServices()
        .patch({
          ...data,
          vlJustVariacaoMaxEfetivo: parseInt(data.vlJustVariacaoMaxEfetivo),
          vlJustVariacaoMinEfetivo: getNegativeNumber(
            data.vlJustVariacaoMinEfetivo
          ),
          vlJustVariacaoNumHomemMax: parseInt(data.vlJustVariacaoNumHomemMax),
          vlJustVariacaoNumHomemMin: getNegativeNumber(
            -data.vlJustVariacaoNumHomemMin
          ),
          vlVariacaoHorasExtras: parseInt(data.vlVariacaoHorasExtras)
        })
        .then(() => {
          setLoading('idle')
          toggleModal()
        })
        .catch((err) => {
          // setMsgErro(err.title || 'Ocorreu um erro, tente novamente')
          showModal({
            hideButtonCancel: true,
            message: err.title || 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
          setLoading('error')
        })
    } else {
      setLoading('loading')
      delete data.idParametrizacaoEfetivo
      EffectiveParamsServices()
        .create({
          ...data,
          vlJustVariacaoMaxEfetivo: parseInt(data.vlJustVariacaoMaxEfetivo),
          vlJustVariacaoMinEfetivo: getNegativeNumber(
            data.vlJustVariacaoMinEfetivo
          ),
          vlJustVariacaoNumHomemMax: parseInt(data.vlJustVariacaoNumHomemMax),
          vlJustVariacaoNumHomemMin: getNegativeNumber(
            data.vlJustVariacaoNumHomemMin
          ),
          vlVariacaoHorasExtras: parseInt(data.vlVariacaoHorasExtras)
        })
        .then(() => {
          setLoading('idle')
          toggleModal()
        })
        .catch((err) => {
          // setMsgErro(err.title || 'Ocorreu um erro, tente novamente')
          showModal({
            hideButtonCancel: true,
            message: err.title || 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
          setLoading('error')
        })
    }
  }

  useEffect(() => {
    setLoading('loading')

    EffectiveParamsServices()
      .get()
      .then(({ data }) => {
        setEffectiveParamsData(data[0])

        setValue('vlJustVariacaoMinEfetivo', data[0]?.vlJustVariacaoMinEfetivo)
        setValue(
          'vlJustVariacaoNumHomemMin',
          data[0]?.vlJustVariacaoNumHomemMin
        )

        setValue('vlJustVariacaoMaxEfetivo', data[0]?.vlJustVariacaoMaxEfetivo)
        setValue(
          'vlJustVariacaoNumHomemMax',
          data[0]?.vlJustVariacaoNumHomemMax
        )
        setValue('vlVariacaoHorasExtras', data[0]?.vlVariacaoHorasExtras)
        setInicioFechamentoFornecedorContraparte(
          data[0]?.dsInicioFechamentoFornecedorContraparte
        )
        setFimFechamentoFornecedorContraparte(
          data[0]?.dsFimFechamentoFornecedorContraparte
        )
        setInicioFechamentoAnalista(data[0]?.dsInicioFechamentoAnalista)
        setFimFechamentoAnalista(data[0]?.dsFimFechamentoAnalista)
        setValorHe(
          data[0]?.flValorHeSalarioBasePorColaborador == true ? 'sim' : 'nao'
        )
        //Estado inicial do DatePicker Analista
        onChangediaAnalistaIni(
          FORMAT.dayToDate(data[0]?.dsInicioFechamentoAnalista)
        )
        onChangediaAnalistaFim(
          FORMAT.dayToDate(data[0]?.dsFimFechamentoAnalista)
        )
        //Estado inicial do DatePicker Fornecedor
        onChangediaFornecedorIni(
          FORMAT.dayToDate(data[0]?.dsInicioFechamentoFornecedorContraparte)
        )
        onChangediaFornecedorFim(
          FORMAT.dayToDate(data[0]?.dsFimFechamentoFornecedorContraparte)
        )

        setLoading('idle')
      })
      .catch((err) => {
        setLoading('error')
        // setMsgErro(err.title || 'Ocorreu um erro, tente novamente')
        showModal({
          hideButtonCancel: true,
          message: err.title || 'Erro ao obter os dados da pesquisa.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })
  }, [])

  const [valorHe, setValorHe] = useState(
    effectiveParamsData?.flValorHeSalarioBasePorColaborador == true
      ? 'sim'
      : 'nao'
  )

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        updateEffectiveParams({
          ...data,
          dsFimFechamentoAnalista: dsFimFechamentoAnalista,
          dsFimFechamentoFornecedorContraparte:
            dsFimFechamentoFornecedorContraparte,
          dsInicioFechamentoAnalista: dsInicioFechamentoAnalista,
          dsInicioFechamentoFornecedorContraparte:
            dsInicioFechamentoFornecedorContraparte,
          flValorHeSalarioBasePorColaborador: valorHe === 'sim' ? true : false,
          idParametrizacaoEfetivo:
            effectiveParamsData?.idParametrizacaoEfetivo > 0
              ? effectiveParamsData?.idParametrizacaoEfetivo
              : -1
        })
      })}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Col gap="2rem">
        <Col marginTop={SPACING.spacing10}>
          <RadioGroup
            row
            defaultValue={valorHe}
            value={valorHe}
            label="Valor HE / Salário Base por Colaborador"
            listOptions={[
              { label: 'Sim', value: 'sim' },
              { label: 'Não', value: 'nao' }
            ]}
            onChange={(e) => setValorHe(e.target.value)}
          />
        </Col>
        <Col gap="1rem">
          <Span fontSize="1rem" fontWeight="bold" text="DIAS DE FECHAMENTO" />
          <Row gap="6rem">
            <Col>
              <Span
                text="Dia Fechamento Fornecedor / Contraparte"
                color={COLORS.black}
                fontSize={TYPOGRAPHY.bodySize14}
                fontWeight={FONTS.bold}
                marginBottom=".6rem"
              />
              <Row alignItems="center" gap="1rem">
                <Col>
                  <Picker
                    type="day"
                    allowTyping={false}
                    formValue={diaFornecedorIni}
                    value={diaFornecedorIni}
                    onChange={onChangediaFornecedorIni}
                    maxDate={moment(diaFornecedorFim).subtract(1, 'd')}
                    minDate={moment().startOf('month')}
                    placeholder="Inicial"
                  />
                  <Span
                    marginTop={SPACING.spacing5}
                    text={`Início dia: ${dsInicioFechamentoFornecedorContraparte}`}
                    color={withDateColor(
                      dsInicioFechamentoFornecedorContraparte
                    )}
                  />
                </Col>
                <Col>
                  <Picker
                    type="day"
                    allowTyping={false}
                    formValue={diaFornecedorFim}
                    value={diaFornecedorFim}
                    minDate={moment(diaFornecedorIni).add(1, 'd')}
                    maxDate={moment().endOf('month')}
                    onChange={onChangediaFornecedorFim}
                    placeholder="Final"
                  />
                  <Span
                    marginTop={SPACING.spacing5}
                    text={`Fim dia: ${dsFimFechamentoFornecedorContraparte}`}
                    color={withDateColor(dsFimFechamentoFornecedorContraparte)}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Span
                text="Dia Fechamento Analista"
                color={COLORS.black}
                fontSize={TYPOGRAPHY.bodySize14}
                fontWeight={FONTS.bold}
                marginBottom=".6rem"
              />
              <Row alignItems="center" gap="1rem">
                <Col>
                  <Picker
                    type="day"
                    allowTyping={false}
                    formValue={diaAnalistaIni}
                    value={diaAnalistaIni}
                    onChange={onChangediaAnalistaIni}
                    maxDate={moment(diaAnalistaFim).subtract(1, 'd')}
                    minDate={moment().startOf('month')}
                    placeholder="Inicial"
                  />
                  <Span
                    marginTop={SPACING.spacing5}
                    text={`Início dia: ${dsInicioFechamentoAnalista}`}
                    color={withDateColor(dsInicioFechamentoAnalista)}
                  />
                </Col>
                <Col>
                  <Picker
                    type="day"
                    allowTyping={false}
                    formValue={diaAnalistaFim}
                    value={diaAnalistaFim}
                    onChange={onChangediaAnalistaFim}
                    minDate={moment(diaAnalistaIni).add(1, 'd')}
                    maxDate={moment().endOf('month')}
                    placeholder="Final"
                  />
                  <Span
                    marginTop={SPACING.spacing5}
                    text={`Fim dia: ${dsFimFechamentoAnalista}`}
                    color={withDateColor(dsFimFechamentoAnalista)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col gap="1rem" marginTop={SPACING.spacing5}>
          <Span fontSize="1rem" fontWeight="bold" text="EFETIVO NÚMERO" />
          <Row gap="1.2rem">
            <InputMask
              control={control}
              errors={errors}
              label="Justificativa Variação % Min"
              placeholder="%"
              formValue="vlJustVariacaoMinEfetivo"
              type="number"
              mask="999"
              maskChar={''}
              required
            />
            <InputMask
              control={control}
              errors={errors}
              label="Justificativa Variação % Max"
              placeholder="%"
              formValue="vlJustVariacaoMaxEfetivo"
              mask="999"
              maskChar={''}
              required
            />
            <InputMask
              control={control}
              errors={errors}
              label="Justificativa Variação Nº Homem Min"
              placeholder="Qtde. Homem"
              formValue="vlJustVariacaoNumHomemMin"
              type="number"
              mask="999"
              maskChar={''}
              required
            />
            <InputMask
              control={control}
              errors={errors}
              label="Justificativa Variação Nº Homem Max"
              placeholder="Qtde. Homem"
              formValue="vlJustVariacaoNumHomemMax"
              type="number"
              maxLength={5}
              maskChar={''}
              required
            />
          </Row>
        </Col>
        <Col gap="1rem">
          <Span fontSize="1rem" fontWeight="bold" text="HORAS EXTRAS" />
          <Row gap="1rem">
            <InputMask
              control={control}
              errors={errors}
              label="Variação %"
              formValue="vlVariacaoHorasExtras"
              placeholder="%"
              mask="999"
              maskChar={''}
              required
            />
          </Row>
        </Col>
      </Col>
      <Row marginBottom={SPACING.spacing30} justifyContent="flex-end">
        <Button text="Limpar" variantButton="text" onClick={handleReset} />
        <Button text="Salvar" type="submit" marginRight={SPACING.spacing20} />
      </Row>
      <SuccessModal
        open={isModalOpen}
        message="Dados foram salvos com sucesso!"
        type="sucess"
        hideButtonCancel
        txtButtonConfirm="OK"
        handleConfirm={() => {
          toggleModal()
        }}
      />
      <SuccessModal
        open={loading === 'error'}
        message={msgErro}
        type="error"
        hideButtonCancel
        handleConfirm={() => setLoading('idle')}
        txtButtonConfirm="Voltar"
      />
    </Form>
  )
}

export default Effective
